import React from 'react';
import Notification from '../../Shared/Notifications';
import { getRanges } from './services/officials';
import { getRules } from '../rules/services/rules';
import { createOrUpdateOfficial } from '../users/services/users';
import ClipLoader from "react-spinners/ClipLoader";
import { BUTTON_LINE_ICON } from '../../Shared/Constants';
import { ToastContainer, toast } from 'react-toastify';
import { isValidEmail } from '../../Shared/functions';


class NewOfficial extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            /* profile data */
            firstName: '',
            firstLastName: '',
            identification:'',
            phone: '',
            address:'',
            birthDay: new Date(),
            gender:'M',
            age:0,
            initPolice:'',
            center:'',
            department:'',
            code:'',

            /* user data */
            fullname: '',
            email: '',
            username: '',
            password: '',
            secondPassword:'',
            
            
            ranges: null,
            rules: null,
            idRange:null,
            rule:null,
            showNotification: false,
            disabledButton: false,
            loadingRange: true,
            loadingForm: true,
            isUpdate: false,

            id:0
        };
    }

    checkEmail = (email) => isValidEmail(email);

    setDefaultData(item){
        this.setState({
            firstName:item.firstName,
            firstLastName:item.firstLastName,
            identification:item.identification,
            phone:Array.isArray(item.phone) ? item.phone : [item.phone],
            address:item.address,
            birthDay:this.formatDate(new Date(item.birthDay)),
            gender:item.gender,
            age:item.age,
            isUpdate:true,
            email:item.email,
            idRange:item.idRange,
            username:item.userName,
            initPolice:item.initPolice,
            center: item.center,
            department:item.department,
            code:item.code,
            id:item.pks,
        })
    }

    formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();  
        return `${year}-${month}-${day}`;  
    }


    endUserCreation = () => {
        const body = {
            id:this.state.id,
            idRange:parseInt(this.state.idRange),
            identification:this.state.identification,
            firstName:this.state.firstName,
            firstLastName:this.state.firstLastName,
            birthDay:this.state.birthDay+'T00:00:00.285Z',
            gender:this.state.gender,
            phone:Array.isArray(this.state.phone) ? this.state.phone : [this.state.phone],
            email:String(this.state.email ?? '').trim(),
            address:this.state.address,
            initPolice:this.state.initPolice,
            center:this.state.center,
            department:this.state.department,
            code:this.state.code,
            userName:this.state.username,
            passW:this.state.password,
            image:'', // default empty,
            signature:'', // default empty
            age:0,
            active:true
        }
    if(this.state.isUpdate) {
        this.updateUser(body)
    }else{
        if(!this.checkEmail(this.state.email)) {
            toast('Por favor ingrese un email valido');
            return;
        }

        if(this.state.birthDay === '') {
            toast('La fecha de nacimiento es obligatoria')
            return;
        }

        if(this.state.password !== '' && this.state.username === '') {
            toast('Por favor digite su nombre de usuario');
            return;
        }

        if(!this.state.idRange || this.state.idRange === 0) {
            toast('El rango del usuario es obligatorio')
            return;
        }

        if(this.state.username === '') {
            toast('El nombre de usuario es requerido')
            return;
        }

        this.setState({loadingForm:true});
        this.newUser(body);
    }

    }

    updateUser(body) {
        this.setState({loadingForm:true})
        createOrUpdateOfficial(body).then((result) => {
            toast(result.data.message);
            this.resetForm();
            this.props.closeDialog();
            this.setState({loadingForm:false, loading:false});
        }).catch((error) => {
            toast(error);
            this.setState({loadingForm:false})
        })
    }

    newUser(body){
        createOrUpdateOfficial(body).then((result) => {
            toast(result.data.message);
            this.resetForm();
            this.props.closeDialog();
            this.setState({loadingForm:false, loading:false});
        }).catch(error => {
            toast(error);
            this.setState({loadingForm:false});
            //this.setState({loadingForm:false, loading:false})
        });
    }

    getRoleById = (id) => {
        let role = this.state.rules.find((rule) => rule.id === id);
        return role.roleName;
    }

    renderNotification = () => {
        return(
            <Notification 
                show={this.state.showNotification}
                title={'Datos almacenados'}
                subtitle={'Sus datos fueron almacenados correctamente.'}
            />
        )
    }

    async componentDidMount() {
        if(this.props && this.props.item) {
            this.setDefaultData(this.props.item);
        }
        await Promise.all([
            getRanges({id: 0,idAdminDescrip: 4,active: true,limit:500}),
            getRules({id:null,roleName:null, limit:500})
        ]).then((result) => {
            this.setState({loadingRange: false, ranges: result[0].data.data, rules: result[1].data.data, loadingForm:false});
        }).catch((err) => {
            this.setState({loading:false})
        })
    }

    resetForm = () => {
        this.setState({
            /* profile data */
            firstName: '',
            firstLastName: '',
            identification:'',
            phone: '',
            address:'',
            birthDay: new Date(),
            gender:'M',
            age:0,
            initPolice:'',
            center:'',
            department:'',
            code:'',

            /* user data */
            fullname: '',
            email: '',
            username: '',
            password: '',
            secondPassword:'',
            
            
            ranges: null,
            rules: null,
            idRange:null,
            rule:null,
            showNotification: false,
            disabledButton: false,
            loadingRange: true,
            loadingForm: true,
            isUpdate: false,

            id:0
        });
    }

    renderForm() {
        return(
            <div className='space-y-12'>
                <div className="border-b border-gray-900/10 pb-12">
                    <h2 className="text-base/7 font-semibold text-gray-900">Datos Personales</h2>
                    <p className="mt-1 text-sm/6 text-gray-600">
                        Esta informacion es completamente confidencial, asegurese de ingresar los datos correctamente.
                    </p>
                    <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

                        <div className='sm:col-span-4'>
                                <label htmlFor="location" className="block text-sm/6 font-medium text-gray-900">
                                    Seleccione Rango
                                </label>
                                <select
                                    onChange={(e) => {this.setState({idRange:e.target.value})}}
                                    id="location"
                                    name="location"
                                    defaultValue={this.state.idRange}
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                >
                                    <option value={null}>SELECCIONAR</option>
                                    {
                                        this.state.ranges?.map((range) => {
                                            return (
                                                    <option key={range.id} value={range.id}>{range.value}</option>
                                                )
                                            })
                                    }
                                </select>
                            </div>
                            <div className="sm:col-span-4">
                                <label htmlFor='identification' className="text-base/7 font-semibold text-gray-900">
                                    Identificación
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.identification}
                                                onChange={(e) => {
                                                    if (!isNaN(e.target.value)) {
                                                      this.setState({ identification: e.target.value });
                                                    }
                                                  }}
                                                id="identification"
                                                name="identification"
                                                type="text"
                                                placeholder=""
                                                autoComplete=""
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="sm:col-span-4">
                                <label htmlFor='fullname' className="text-base/7 font-semibold text-gray-900">
                                    Nombres
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.firstName}
                                                onChange={(e) => {this.setState({firstName: e.target.value})}}
                                                id="fullname"
                                                name="fullname"
                                                type="text"
                                                placeholder=""
                                                autoComplete=""
                                                className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="sm:col-span-4">
                                <label htmlFor='fullname' className="text-base/7 font-semibold text-gray-900">
                                    Apellidos
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.firstLastName}
                                                onChange={(e) => {this.setState({firstLastName: e.target.value})}}
                                                id="fullname"
                                                name="fullname"
                                                type="text"
                                                placeholder=""
                                                autoComplete=""
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="sm:col-span-4">
                                <label htmlFor='phone' className="text-base/7 font-semibold text-gray-900">
                                    Fecha de nacimiento
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-npm rusm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.birthDay}
                                                onChange={(e) => {this.setState({birthDay: e.target.value})}}
                                                id="phone"
                                                name="phone"
                                                type="date"
                                                placeholder=""
                                                autoComplete=""
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className='sm:col-span-4'>
                                <div>
                                    <label htmlFor="location" className="block text-sm/6 font-medium text-gray-900">
                                        Género
                                    </label>
                                    <select
                                        value={this.state.gender}
                                        onChange={(e) => {this.setState({gender:e.target.value})}}
                                        id="location"
                                        name="location"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                    >
                                        <option value={null}>SELECCIONAR</option>
                                        <option value={'M'}>Masculino</option>
                                        <option value={'F'}>Femenino</option>
                                    </select>
                                </div>
                            </div>
                            <div className="sm:col-span-4">
                                <label htmlFor='phone' className="text-base/7 font-semibold text-gray-900">
                                    Teléfono
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.phone}
                                                onChange={(e) => {
                                                    if (!isNaN(e.target.value)) {
                                                      this.setState({ phone: e.target.value });
                                                    }
                                                  }}
                                                id="phone"
                                                name="phone"
                                                type="text"
                                                placeholder=""
                                                autoComplete=""
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="sm:col-span-4">
                                <label htmlFor='email' className="text-base/7 font-semibold text-gray-900">
                                    Correo electrónico
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.email}
                                                onChange={(e) => {this.setState({email: e.target.value})}}
                                                id="email"
                                                name="email"
                                                type="text"
                                                placeholder=""
                                                autoComplete=""
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="sm:col-span-4">
                                <label htmlFor='phone' className="text-base/7 font-semibold text-gray-900">
                                    Dirección
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.address}
                                                onChange={(e) => {this.setState({address: e.target.value})}}
                                                id="phone"
                                                name="phone"
                                                type="text"
                                                placeholder=""
                                                autoComplete=""
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="sm:col-span-4">
                                <label htmlFor='phone' className="text-base/7 font-semibold text-gray-900">
                                    Unidad Policial
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.initPolice}
                                                onChange={(e) => {this.setState({initPolice: e.target.value})}}
                                                id="phone"
                                                name="phone"
                                                type="text"
                                                placeholder=""
                                                autoComplete=""
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="sm:col-span-4">
                                <label htmlFor='phone' className="text-base/7 font-semibold text-gray-900">
                                    Centro Policial
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.center}
                                                onChange={(e) => {this.setState({center: e.target.value})}}
                                                id="phone"
                                                name="phone"
                                                type="text"
                                                placeholder=""
                                                autoComplete=""
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="sm:col-span-4">
                                <label htmlFor='phone' className="text-base/7 font-semibold text-gray-900">
                                    Departamento
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.department}
                                                onChange={(e) => {this.setState({department: e.target.value})}}
                                                id="phone"
                                                name="phone"
                                                type="text"
                                                placeholder=""
                                                autoComplete=""
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="sm:col-span-4">
                                <label htmlFor='phone' className="text-base/7 font-semibold text-gray-900">
                                    Codigo de funcionario
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.code}
                                                onChange={(e) => {
                                                    if (!isNaN(e.target.value)) {
                                                      this.setState({ code: e.target.value });
                                                    }
                                                  }}
                                                id="phone"
                                                name="phone"
                                                type="text"
                                                placeholder=""
                                                autoComplete=""
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>  
                    </div>
                </div>
                    <div className="border-b border-gray-900/10 pb-12">
                        <h2 className="text-base/7 font-semibold text-gray-900">Datos del usuario</h2>
                        <p className="mt-1 text-sm/6 text-gray-600">
                        Por favor diligencie un nombre de usuario que sea fácil de recordar así como una contraseña con el mínimo nivel de seguridad requerido (1 Carácter especial, 1 Mayúscula, 1 Número)
                        </p>
                        <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="sm:col-span-4">
                                <label htmlFor='username' className="text-base/7 font-semibold text-gray-900">
                                    Nombre de usuario
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.username}
                                                onChange={(e) => {this.setState({username: e.target.value})}}
                                                id="username"
                                                name="username"
                                                type="text"
                                                placeholder=""
                                                autocomplete="new-password"
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="sm:col-span-4">
                                <label htmlFor='password' className="text-base/7 font-semibold text-gray-900">
                                    Contraseña
                                </label>
                                <div className="mt-2">
                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                            <input
                                                value={this.state.password}
                                                onChange={(e) => {this.setState({password: e.target.value})}}
                                                id="password"
                                                name="password"
                                                type="password"
                                                placeholder=""
                                                autocomplete="new-password"
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </div>
                            
                            {
                                /* 
                                    <div className="sm:col-span-4">
                                        <label htmlFor='password_confirm' className="text-base/7 font-semibold text-gray-900">
                                            Confirmar Contraseña
                                        </label>
                                        <div className="mt-2">
                                            <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                                    <input
                                                        value={this.state.secondPassword}
                                                        onChange={(e) => {this.setState({secondPassword: e.target.value})}}
                                                        id="password_confirm"
                                                        name="password_confirm"
                                                        type="password"
                                                        placeholder=""
                                                        autoComplete=""
                                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                                    />
                                            </div>
                                        </div>
                                    </div>
                                */
                            }
                            
                        </div>
                    </div>
                {
                    this.state.loadingRange ? 
                        <center>
                            <ClipLoader
                                color={'gray'}
                                loading={true}
                                size={50}
                                aria-label="Loading Spinner"
                                data-testid="loader"/>
                        </center>
                    :
                    <div>
                        <div>
                            <button 
                                onClick={() => {this.endUserCreation()}}
                                type="button"
                                className={BUTTON_LINE_ICON}>
                                FINALIZAR
                            </button>
                            <button  
                                className='bg-white text-gray-900'
                                style={{marginLeft:10}}                  
                                onClick={() => {this.props.closeDialog()}}
                                type="button"
                            >
                                CANCELAR
                            </button>
                        </div>
                    </div>
                    

                }
                

                {this.renderNotification()}
            </div>
        )
    }  

    render() {
        return(<div>
            {
                !this.state.loadingForm ? 
                    this.renderForm()
                :
                <center>
                    <ClipLoader
                        color={'gray'}
                        loading={true}
                        size={50}
                        aria-label="Loading Spinner"
                        data-testid="loader"/>
                </center>
            }
            <ToastContainer position="top-center" hideProgressBar={true}/>  
        </div>)
    }
}

export default NewOfficial;